import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ExportFileFacade, LoadDataFacade, SetInitialStateFacade } from '../../../../common/models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../list-search-criteria';
import { AddressListSearchCriteria } from '../models';
import { AddressListExportToFileStart, AddressListInitialState, AddressListLoad } from './address-list.actions';
import { AddressListState, AddressListStateModel } from './address-list.state';
import { MatDialogRef } from '@angular/material/dialog';
import { ExportAddress } from '../constants';
import { ExportDialogComponent } from '../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class AddressListFacade implements LoadDataFacade, SetInitialStateFacade, ExportFileFacade {
  reportName: string;
  listDto$: Observable<AddressListStateModel> = this.store.select(AddressListState.getState);
  loaded$: Observable<boolean> = this.store.select(AddressListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.AddressManagement)
      .subscribe((filter: AddressListSearchCriteria) => {
        this.store.dispatch(new AddressListLoad(filter));
      });
  }

  /**
   * starting export excel file
   */
  startExportToFile(
    name: string,
    dialogRef: MatDialogRef<ExportDialogComponent>,
    navigationNeeded: boolean,
    addressExport: ExportAddress,
  ): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.AddressManagement)
      .subscribe((searchItem: AddressListSearchCriteria) => {
        const { size: _size, page: _page, ...filterView } = searchItem;
        this.store.dispatch(
          new AddressListExportToFileStart({
            name,
            filterView,
            dialogRef,
            navigationNeeded,
            addressExport,
          }),
        );
      });
  }

  setInitialState(): void {
    this.store.dispatch(new AddressListInitialState());
  }
}
